/**
 * 6th Panel — main.js
 * Supplements Dawn's cart-drawer.js. Keeps the header cart badge in sync
 * whenever the cart changes via the pubsub system.
 */

document.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const count = event?.cartData?.item_count ?? 0;
    document.querySelectorAll('[data-sixth-cart-count]').forEach((el) => {
      el.textContent = count;
      if (count === 0) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
      }
    });
    document.querySelectorAll('.sixth-header__cart').forEach((el) => {
      el.setAttribute('aria-label', `Cart, ${count} item${count !== 1 ? 's' : ''}`);
    });
  });
});
